import { contentful } from './api';

export default {
    getConfirmation(slug) {
        return Promise.all([
            contentful.getEntries({
                content_type: 'confirmation',
                'fields.slug': slug,
                include: 1
            }),
        ]).then(([value]) => {
            return value
        })
    },
}